import classNames from 'classnames';
import * as React from 'react';

export const FILL_LOW_ACTIVITY = '#28424F';
export const FILL_MID_ACTIVITY = '#006B99';
export const FILL_HIGH_ACTIVITY = '#E84B25';
export const FILL_FEATURED = '#308800';
export const FILL_FAVORITE = '#F3A626';
export interface PinProps {
  favorite?: boolean;
  featured?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  fishingReportCount?: number;
  hasSummary?: boolean;
  hasSurveyData?: boolean;
  lunkerPotential?: boolean;
}

export const formatFishingReportsCount = (num: number): string => {
  if (num >= 1000) {
    let formattedNumber = num / 1000;
    // If the number is less than 1100, show it as a whole number
    if (num < 1100) {
      return `${Math.floor(formattedNumber)}k`;
    } else {
      // Otherwise, show it with one decimal place
      formattedNumber = parseFloat(formattedNumber.toFixed(1));
      return `${formattedNumber}k`;
    }
  }
  return num.toString();
};

export const PinLowActivity = (props: PinProps) => {
  const { onClick, className } = props;

  return (
    <div className={classNames('relative', className)} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="34"
        viewBox="0 0 31 34"
        fill="none"
      >
        <g opacity="0.25">
          <path
            d="M15.0466 32.6359C14.4782 32.3569 1.0332 25.6292 1.0332 15.6255C1.0332 7.58542 7.52317 1.03345 15.5013 1.03345C23.4794 1.03345 29.9694 7.58542 29.9694 15.6255C29.9694 25.7842 16.5244 32.3569 15.9457 32.6359L15.491 32.8529L15.0362 32.6359H15.0466Z"
            fill="white"
          />
          <path
            d="M15.5015 2.06687C22.9216 2.06687 28.9362 8.14347 28.9362 15.6255C28.9362 25.2468 15.5015 31.7058 15.5015 31.7058C15.5015 31.7058 2.06687 25.1021 2.06687 15.6255C2.06687 8.14347 8.08146 2.06687 15.5015 2.06687ZM15.5015 0C6.95501 0 0 7.00669 0 15.6255C0 26.2596 13.9927 33.2663 14.5921 33.5556L15.4912 34L16.4006 33.566C17 33.2766 31.003 26.4249 31.003 15.6255C31.003 7.00669 24.048 0 15.5015 0Z"
            fill="black"
          />
        </g>
        <path
          d="M15.5008 30.5483C13.2169 29.3186 3.09961 23.4073 3.09961 15.6359C3.09961 8.73254 8.65949 3.11066 15.5008 3.11066C22.3422 3.11066 27.902 8.73254 27.902 15.6359C27.902 23.5417 17.7847 29.3392 15.5008 30.5483Z"
          fill="#061622"
        />
        <path
          d="M15.5011 4.13373C21.774 4.13373 26.8688 9.29057 26.8688 15.6255C26.8688 22.4979 18.343 27.7891 15.5114 29.3599C14.3333 28.6985 12.1837 27.386 10.0549 25.5775C7.35759 23.2833 4.13328 19.6973 4.13328 15.6152C4.13328 9.28024 9.22811 4.1234 15.5011 4.1234M15.5011 2.06686C8.08099 2.06686 2.06641 8.14346 2.06641 15.6255C2.06641 25.1021 15.5011 31.7058 15.5011 31.7058C15.5011 31.7058 28.9357 25.2468 28.9357 15.6255C28.9357 8.13313 22.9211 2.06686 15.5011 2.06686Z"
          fill="white"
        />
        <path
          d="M16.4415 16.5725C16.4788 16.6367 17.6551 17.4067 17.7298 17.4159C18.0659 17.4434 20.1385 15.5825 20.54 16.0408C21.2682 16.875 18.6915 18.5342 17.9726 18.5892C17.0296 18.6625 15.9186 17.2967 15.6572 17.2784C15.2184 17.2509 13.874 18.6809 13.0338 18.5984C12.791 18.5709 10.513 17.15 10.4663 17.0033C9.6541 14.62 12.8377 17.4434 13.0338 17.4709C13.1271 17.4892 14.5649 16.6825 14.6116 16.6092C14.8263 16.3067 12.9778 13.9508 12.7724 13.3458C11.2412 8.84486 17.7485 7.86401 18.4114 11.6041C18.7475 13.5016 16.0027 15.8483 16.4321 16.5817L16.4415 16.5725ZM15.7973 15.1516C15.9466 15.0508 17.3284 12.2183 17.291 11.8241C17.123 10.1191 13.3792 9.71571 13.7433 12.3649C13.8273 12.9608 15.2091 15.555 15.7973 15.1516Z"
          fill="white"
        />
        <path
          d="M20.6527 18.7827C20.6527 18.7827 20.71 20.0149 20.605 20.1618C20.5096 20.2862 19.9847 20.2297 19.7842 20.4218C16.6538 23.3723 16.9211 20.1166 15.4036 20.2862C14.7355 20.3653 14.306 21.3827 13.7811 21.5749C12.0918 22.174 11.7864 20.4897 10.3453 20.0036C10.164 16.9288 12.2064 20.3427 13.218 20.2297C13.9147 20.1505 14.3824 18.8505 15.375 18.7827C16.6443 18.681 17.0833 20.3427 18.0568 20.2297C18.6676 20.1618 19.9751 17.9688 20.6432 18.7827H20.6527Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
PinLowActivity.width = 36;
PinLowActivity.height = 36;
